import React from 'react';
import { Check, Clock, Loader2, AlertTriangle, X } from 'lucide-react';
import { StatusBadge } from '../common/StatusBadge';
import { applicationSteps } from '../../data/ownerAdmin';
import { stepState } from '../../utils/ownerStatus';
import { toBn } from '../../utils/bn';
import type { OwnerApplication } from '../../types/owner';
export function AppTimeline({
  app
}: {
  app: OwnerApplication;
}) {
  return <ol className="relative" data-id="element-1241" data-mp="22huyfoju7kg4">
      {applicationSteps.map((s, i) => {
      const st = stepState(app.stage, i, app.status);
      const Icon = st.tone === 'green' ? Check : st.tone === 'blue' ? Loader2 : st.tone === 'orange' ? AlertTriangle : st.tone === 'red' ? X : Clock;
      const dot = {
        green: 'bg-bdgreen-600 text-white',
        blue: 'bg-blue-600 text-white',
        orange: 'bg-amber-500 text-white',
        red: 'bg-red-600 text-white',
        gray: 'bg-slate-200 text-slate-500'
      }[st.tone];
      return <li key={s.label} className="relative flex gap-3 pb-4 last:pb-0" data-id="element-1242" data-mp="2u28nv7622459" data-mpi={i}>
            {i < applicationSteps.length - 1 && <span className={`absolute left-[15px] top-8 h-[calc(100%-24px)] w-0.5 ${i < app.stage ? 'bg-bdgreen-600' : 'bg-slate-200'}`} aria-hidden data-id="element-1243" data-mp="2ysp2gulm3vt7" />}
            <span className={`relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${dot}`} data-id="element-1244" data-mp="2l3etzok3zrve">
              <Icon className={`h-4 w-4 ${st.tone === 'blue' ? 'animate-spin [animation-duration:2.5s]' : ''}`} strokeWidth={2.5} data-id="element-1245" data-mp="2p0szb54o5fi4" />
            </span>
            <div className="min-w-0 flex-1 pt-0.5" data-id="element-1246" data-mp="3hqrt1dtt60t4">
              <div className="flex items-start justify-between gap-2" data-id="element-1247" data-mp="3hpgqfhc3mz3l">
                <p className={`text-[13.5px] font-semibold ${st.tone === 'gray' ? 'text-slate-400' : 'text-navy-900'}`} data-id="element-1248" data-mp="33rs5k9i17ryj">
                  {toBn(i + 1)}. {s.label}
                </p>
                <StatusBadge tone={st.tone} className="!px-2 !text-[10.5px]" data-id="element-1249" data-mp="1sc3jdkclqwys">{st.label}</StatusBadge>
              </div>
              <p className="text-[11px] text-slate-500" data-id="element-1250" data-mp="1xdar5jeqvw5g">
                {s.who}
                {app.times[i] && <> • {app.times[i]}</>}
              </p>
            </div>
          </li>;
    })}
    </ol>;
}